<template>
  <div>
    <b-modal
      class="modal-assessment-kpi"
      id="modal-assessment-kpi"
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      title="Assessment Key Performance Indicator"
    >
      <div class="mt-1 mb-3">
        <div class="form-kpi mt-4 mr-3 ml-3 text-muted">
          <div>
            <h6 class="mb-3">Key Performance Indicator</h6>
              <b-container>
                <b-row>
                  <b-col md="4" v-for="(kpiItem, index) in kpi" :key="index" class="mb-3">
                    <b-form-group
                      class="objective-kpi ml-1 d-flex"
                      :label="kpiItem.objective"
                    >
                      <div class="d-flex">
                        <div class="form-input-kpi mr-2">
                          <b-form-input
                            placeholder="Enter Key Performance Indicator"
                            v-model="temp[index].name"
                            required
                          ></b-form-input>
                        </div>
                        <div>
                          <b-button variant="warning" class="mb-2" @click="addKpi(kpiItem.objective, kpiItem.idObjective, index, temp[index].name)">
                            <b-icon class="text-white" icon="check"></b-icon>
                          </b-button>
                        </div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-container>
            <div class="mt-3 mb-3">
              <table-key-performance-indicator
                :kpi="selectedKpi"
                @data="recieveData"
                @remove="removeVariantKpi"
              />
            </div>
          </div>
        </div>
        <div class="mt-3 d-flex justify-content-center">
          <b-button
            class="text-white"
            variant="warning"
            type="submit"
            block
            @click="postAssesment"
            :disabled="dataFormIsNull"
          >
            Save
            <b-spinner
              v-if="isBusy"
              class="ml-1"
              label="Spinning"
              small
            />
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import tableKeyPerformanceIndicator from './TableKpi.vue'
import api from '@/api'

export default {
  props: {
    employee: {
      type: Object,
      default: () => {}
    },
    objectives: {
      type: Array,
      default: () => []
    },
    objectivePerEmployee: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    tableKeyPerformanceIndicator
  },
  data() {
    return {
      dataForm: [
        {
          idEmployee: '',
          kpi: {}
        }
      ],
      kpi: [],
      forUpdateKpi: {
        year: '',
        kpiId: '',
        summary: 0,
        employeeId: ''
      },
      kpiId: '',
      isBusy: false,
      kpiIsEmpty: false,
      openTableQPD: false,
      messageResult: {
        message: '',
        variant: ''
      },
      buttonActive: true,
      selectedKpi: [],
      dataFormIsNull: true,
      temp: []
    }
  },
  methods: {
    resetKpi() {
      this.dataForm = [
        {
          idEmployee: '',
          kpiId: '',
          kpi: {}
        }
      ]
    },
    recieveData(data) {
      this.dataForm.idEmployee = this.employee.id
      this.dataForm.kpi = data
      this.dataFormIsNull = false
    },
    async postAssesment() {
      this.isBusy = true
      let summaryKpi = 0
      try {
        const promises = []
        for (const kpiItem of this.dataForm.kpi) {
          if (
            kpiItem.kpi &&
            kpiItem.idObjective &&
            kpiItem.weight !== undefined &&
            kpiItem.target !== undefined &&
            kpiItem.realization !== undefined &&
            kpiItem.score !== undefined &&
            kpiItem.finalScore !== undefined
          ) {
            const payload = {
              kpiId: this.kpiId,
              name: kpiItem.kpi,
              objectiveId: kpiItem.idObjective,
              weight: kpiItem.weight,
              target: kpiItem.target,
              realization: kpiItem.realization,
              score: kpiItem.score,
              finalScore: kpiItem.finalScore,
              type: kpiItem.kpiType === 'Maximum'
            }
            summaryKpi += payload.finalScore
            promises.push(api.kpi.post(payload))
          }
        }
        if (promises.length === 0) {
          this.isBusy = false
          this.sendResult('Assessment KPI employee failed', 'danger')
          return
        }
        await Promise.all(promises)
        this.updateSummaryKpi(summaryKpi)
        this.isBusy = false
        this.sendResult('Assessment KPI employee success', 'success')
        this.$bvModal.hide('modal-assessment-kpi')
      } catch (error) {
        this.isBusy = false
        console.log(error)
        this.sendResult('Assessment KPI employee failed', 'danger')
        this.$bvModal.hide('modal-assessment-kpi')
      }
      this.resetKpi()
      this.dataFormIsNull = true
      this.isBusy = false
    },
    async updateSummaryKpi(summaryKpi) {
      try {
        await api.kpi.updateSummaryKpi(this.objectivePerEmployee.kpiId, { summary: summaryKpi })
      } catch (error) {
        console.log(error)
      }
    },
    sendResult(message, variant) {
      this.messageResult.message = message
      this.messageResult.variant = variant
      this.$emit('result-request', this.messageResult)
      this.$emit('refresh-table', true)
    },
    addKpi(objective, id, index, nameKpi) {
      if (objective === this.kpi[index].objective) {
        this.kpi[index].kpi.push({
          kpi: nameKpi,
          idObjective: id,
          kpiType: '',
          weight: 0,
          target: 0,
          realization: 0,
          score: 0,
          finalScore: 0
        })
      }
      this.selectedKpi = []
      this.kpi.forEach(items => {
        items.kpi.forEach(item => {
          this.selectedKpi.push(item)
        })
      })
      this.temp[index].name = ''
    },
    removeVariantKpi(data) {
      this.kpi.forEach(item => {
        item.kpi.forEach(kpi => {
          if (kpi.kpi === data.targetKpi) {
            const index = item.kpi.findIndex(item => item.kpi === data.targetKpi)
            if (index !== -1) {
              item.kpi.splice(index, 1)
            }
          }
        })
      })
    }
  },
  watch: {
    objectivePerEmployee: {
      handler() {
        this.kpi = []
        this.forUpdateKpi = {
          year: '',
          kpiId: '',
          summary: 0,
          employeeId: ''
        }
        this.kpiId = ''
        this.kpiId = this.objectivePerEmployee.kpiId
        this.objectivePerEmployee.objective.forEach(item => {
          this.dataForm.kpiId = item.kpiId
          this.kpi.push({
            objective: item.name,
            kpiId: item.kpiId,
            idObjective: item.objectiveId,
            kpi: []
          })
          this.temp.push({
            name: ''
          })
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.content{
  font-size: 16px;
}
.detail-info{
  padding: 0 17px 0 17px;
  .info{
    padding-top: 7px;
    padding-bottom: 7px;
  }
}

.form-kpi{
  padding: 0 17px 0 17px;
  .field-input{
    padding: 0 20px 0 20px;
  }
}

.objective-kpi td{
  vertical-align: baseline;
}

.form-input-kpi{
  width: 35vh;
}
</style>
